import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageDropdown.css";
import i18n from "./i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

function LanguageDropdown() {
	const { i18n } = useTranslation();
	const [selectedLanguage, setSelectedLanguage] = useState("en");

	useEffect(() => {
		i18n.changeLanguage(selectedLanguage);
	}, [selectedLanguage, i18n]);

	const handleChange = (event) => {
		const newLanguage = event.target.value;
		setSelectedLanguage(newLanguage);
		i18n.changeLanguage(newLanguage);
	};

	return (
		<div className="language-dropdown-container">
			<FontAwesomeIcon icon={faGlobe} className="globe-icon" />
			<select
				value={selectedLanguage}
				onChange={handleChange}
				className="language-dropdown"
			>
				<option value="en">English</option>
				<option value="ge">Chinise</option>
			</select>
		</div>
	);
}

export default LanguageDropdown;
